module.exports = __webpack_public_path__ + "static/media/ico-contract.d8956bbe.svg";